import { type FC } from "react";

import { useQuery } from "@apollo/client/react";

import { ProjectTaggedPageDocument } from "@app_schema";

import { Figure } from "@styled/figure";
import { Loader } from "@styled/loader";
import { PageView, PageViewLetter } from "@styled/page_view";

import { type PageTarget } from "../../projects/assistant/page_tag";

const pageRange = (from: number, till: number) =>
  from === till ? `p. ${String(from)}` : `pp. ${String(from)}–${String(till)}`;

// The page a tag opened, in place of the letters (or over the chat under
// 1280), with the letter that holds it.
export const RecordPageView: FC<{
  projectId: string;
  target: PageTarget;
  backLabel: string;
  onBack(): void;
}> = ({ projectId, target, backLabel, onBack }) => {
  const { data, loading } = useQuery(ProjectTaggedPageDocument, {
    variables: {
      id: projectId,
      documentId: target.documentId,
      number: target.page,
    },
  });
  const page = data?.project.taggedPage;
  const letter = page?.letter;

  return (
    <PageView
      backLabel={backLabel}
      onBack={onBack}
      number={target.page}
      filename={page?.filename}
      context={
        letter && (
          <PageViewLetter pages={pageRange(letter.from, letter.till)}>
            {letter.name}
          </PageViewLetter>
        )
      }
    >
      {loading ? (
        <Loader />
      ) : (
        page && <Figure src={page.url} alt={`Page ${String(page.number)}`} />
      )}
    </PageView>
  );
};
